import eventBus from '@lib/utils/eventBus'

export default eventBus
